const _post = async (endpoint) => {
    const res = await fetch(endpoint, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
    }).catch((error) => {
        return false;
    });
    const data = await res;
    return data;
}
export default _post


